// This file contains setup code for tests
import { vi } from "vitest";

// Use Vitest's built-in to mock Date
vi.setSystemTime(new Date("2023-01-01"));
